import { TemplateElement, html, defineElement, when, classMap } from '@webtides/element-js';
import { responsiveImage } from '../../../../directives/images.js';
const style = `mb-hero-text {display: block;}`;
import '../rich-text/rich-text';

/**
 * @property {string} headline
 * @property {string} [text]
 * @property {string} notificationHeadline
 * @property {string} notificationText
 * @property {ImageProperties} notificationImage
 * @property {boolean} notificationImageType
 */
export default class HeroText extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            headline: '',
            text: '',
            notificationHeadline: '',
            notificationText: '',
            notificationImage: undefined,
            notificationImageType: false,
        };
    }

    template() {
        const imgClasses = {
            'w-[135px] absolute -left-[72px] top-1/2 -translate-y-1/2': this.notificationImageType === true,
            'w-[85px] aspect-square object-cover': this.notificationImageType === false,
        };
        const notificationClasses = {
            'relative ml-[72px] gap-[40px] mb-28 mt-16 md:mt-0': this.notificationImageType === true,
            'gap-16 mb-16': this.notificationImageType === false,
        };
        const gridClasses = {
            'md:grid-cols-2': this.notificationHeadline !== '',
            'md:grid-cols-1': this.notificationHeadline === '',
        };
        const headlineWithoutTextClasses = {
            '': this.notificationText !== '',
            'mb-0': this.notificationText === '',
        };
        // TODO: mdx/sys/font/flex/Large/Headline1_Medium is missing from mdx tailwind tokens...
        return html`
            <div class="container container-content">
                <div class="w-full pt-flex-l">
                    <div class="grid ${classMap(gridClasses)}">
                        <h1
                            class="mb-16 lg:mb-24 font-medium leading-[130%] text-[32px] lg:text-[60px] lg:leading-[120%] text-green-medium text-balance"
                        >
                            ${this.headline}
                        </h1>

                        ${when(
                            this.notificationHeadline,
                            html`
                                <div
                                    class="md:mb-0 md:row-span-2 md:ml-auto max-h-max md:w-full max-w-[480px] p-fix-s rounded-md bg-accent-1-subtle1 flex items-center flex-row ${classMap(notificationClasses)}"
                                >
                                    ${when(
                                this.notificationImage,
                                html`
                                    <div class="shrink-0">
                                        ${responsiveImage(
                                        this.notificationImage,
                                        `${classMap(imgClasses)}`,
                                        false,
                                        'auto',
                                        this.notificationImageType === true ? '135px' : '85px',
                                        'eager',
                                    )}
                                    </div>
                                `,
                            )}
                                    <div class="w-full">
                                        <h4
                                            class="fix-title3-medium text-accent-1 ${classMap(headlineWithoutTextClasses)}"
                                        >
                                            ${this.notificationHeadline}
                                        </h4>
                                        ${when(
                                    this.notificationText,
                                    html`
                                        <mb-rich-text
                                            text="${this.notificationText}"
                                            class="h-full w-full fix-body2 text-accent-1 col-span-full"
                                        >
                                        </mb-rich-text>
                                    `,
                                )}
                                    </div>
                                </div>
                            `,
                        )}
                        ${when(
                            this.text,
                            html`
                            <p class="mb-0 lg:w-10/12 text-green-medium fix-body1">${this.text}</div>
                        `,
                        )}
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('mb-hero-text', HeroText);
